
import React from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

const Cookies = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-3xl font-bold text-[#0c4a6e] mb-8">Política de Cookies</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="mb-4">
              Última actualización: {new Date().toLocaleDateString('es-ES', {year: 'numeric', month: 'long', day: 'numeric'})}
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">1. ¿Qué son las Cookies?</h2>
            <p className="mb-4">
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente, así como para proporcionar información a los propietarios del sitio.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">2. Tipos de Cookies que Utilizamos</h2>
            <p className="mb-4">
              Utilizamos varios tipos de cookies en nuestro sitio web:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Cookies esenciales: necesarias para el funcionamiento del sitio web.</li>
              <li>Cookies de preferencias: permiten recordar información para personalizar su experiencia.</li>
              <li>Cookies estadísticas: nos ayudan a entender cómo los visitantes interactúan con el sitio.</li>
              <li>Cookies de marketing: se utilizan para rastrear a los visitantes en los sitios web.</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">3. Control de Cookies</h2>
            <p className="mb-4">
              Puede configurar su navegador para rechazar todas las cookies o para indicar cuándo se está enviando una cookie. Sin embargo, si no acepta cookies, es posible que algunas partes de nuestro sitio web no funcionen correctamente.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">4. Cookies de Terceros</h2>
            <p className="mb-4">
              Además de nuestras propias cookies, también podemos utilizar varias cookies de terceros para informar estadísticas de uso del sitio y entregar anuncios relevantes para usted.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">5. Cambios en nuestra Política de Cookies</h2>
            <p className="mb-4">
              Podemos actualizar nuestra política de cookies periódicamente. Le notificaremos cualquier cambio publicando la nueva política de cookies en esta página.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">6. Contacto</h2>
            <p className="mb-4">
              Si tiene alguna pregunta sobre nuestra política de cookies, por favor contáctenos en:
            </p>
            <p className="mb-4">
              <strong>Email:</strong> <a href="mailto:info@gavinsurance.com" className="text-[#0284c7] hover:underline">info@gavinsurance.com</a><br />
              <strong>Teléfono:</strong> <a href="tel:+17865695142" className="text-[#0284c7] hover:underline">(888) 370-8454</a><br />
              <strong>Dirección:</strong> 7500 NW 25 ST #237, Doral, FL 33122
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Cookies;
